import React, { PropTypes } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import './styles.scss';

export const SettingsConfirm = props => (
  <div
    className="settings-confirm"
    onClick={props.cancel}
    role="button"
    aria-hidden
  >

    <ReactCSSTransitionGroup
      component='div'
      className='animationBlock'
      transitionName='slide'
      transitionAppear
      transitionEnter={false}
      transitionLeave={false}
      transitionAppearTimeout={600}
    >

      {/* The task name the user is confirming */}
      <p className='settings-confirm-title'>{props.title}</p>

      {/* The confirmation modal */}
      <div className="settings-confirm-modal">
        {/* the task description */}
        <p>{props.description}</p>

        {/* the task options */}
        <button className="button-confirm" onClick={props.confirm}>
          <p>Yes</p>
        </button>
        <button className="button-cancel" onClick={props.cancel}>
          <p>Cancel</p>
        </button>
      </div>

    </ReactCSSTransitionGroup>

  </div>
);

SettingsConfirm.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  confirm: PropTypes.func,
  cancel: PropTypes.func,
};


export default SettingsConfirm;



// WEBPACK FOOTER //
// ./src/components/timeclock/userhub/settings/SettingsConfirm/main.jsx